export const characteristics = {
  taille: 'Taille',
  epaisseur: 'Épaisseur',
  nombreDeProduitsParBoite: 'Nombre de produits par boite',
  composition: 'Composition',
  origine: 'Origine',
  pvht: 'Prix de vente HT',
  pvAuxCentGrammes: 'Prix TTC aux 100 grammes',
  titreAlcoometrique: 'Titre alcoométrique',
  ddm: 'Date de Durabilité Minimale (DDM)',
  label: 'Label',
  fournisseur: 'Fournisseur',
  packaging: 'Packaging',
  tva: 'TVA'
};
